<pg-badge
  [type]="badgeModel.type"
  [showIcon]="badgeModel.showIcon"
  [progress]="badgeModel.progressAmount"
  [id]="badgeModel.id"
  [style.background]="badgeModel.backgroundColor"
  [classes]="badgeModel.classes"
>
  <pg-icon
    [style.font-size]="badgeModel.icon.size"
    [style.color]="badgeModel.icon.color"
    *ngIf="badgeModel.icon"
  >
    {{ badgeModel.icon.iconName }}
  </pg-icon>
  <span [style.color]="badgeModel.textColor">{{ badgeModel.label }}</span>
</pg-badge>
